import { useState } from 'react';
import { useSelector } from 'react-redux';
import { getUserId } from 'store/session/selectors';
import { useNavigate, useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import { Card } from 'components/@shared/Card';
import { InvoiceFormData } from 'types/invoice';
import { BackdropLoader } from 'components/@shared/Loaders';
import { useNotifications } from 'hooks/useNotifications';
import { PATH } from 'routes/path';
import { createNewInvoice } from 'services/invoiceService';
import { InvoiceForm } from 'components/Invoices/InvoiceForm';
import { parametrizeURL } from 'routes/utils';
import { ONLY_CONTRACTOR } from 'constants/roles';
import { useDeniedAccess } from 'hooks/useDeniedAccess';

const cardStyles = {
    maxWidth: '700px',
    margin: 'auto',
};
export const CreateInvoicePage = () => {
    const userId = useSelector(getUserId);
    const [isLoading, setIsLoading] = useState(false);

    const notifications = useNotifications();
    const navigate = useNavigate();
    const { appointmentId } = useParams<{ appointmentId: string }>();

    const submitHandler = (form: InvoiceFormData) => {
        setIsLoading(true);
        if (appointmentId) {
            createNewInvoice(form, appointmentId)
                .then(() => {
                    notifications.show({ message: 'Appointment successfully created' });
                    navigate(parametrizeURL(PATH.APPOINTMENT_DETAILS, { id: appointmentId }));
                })
                .finally(() => setIsLoading(false));
        }
    };

    useDeniedAccess(ONLY_CONTRACTOR);

    return (
        <Box width="100%" px={2.5} py={2}>
            <Card title="Invoice" sx={cardStyles}>
                <InvoiceForm onSubmit={submitHandler} />
            </Card>
            {isLoading && <BackdropLoader />}
        </Box>
    );
};
